import LoadingSpinner from '@atoms/LoadingSpinner/LoadingSpinner';
import Modal from '@atoms/Modal/Modal';

interface Props {
  readonly isLoading: boolean;
}

const LoadingOverlay = ({ isLoading }: Props) => (
  <Modal
    isOpen={isLoading}
    transparent
    showCloseButton={false}
    modalClasses="flex items-center justify-center"
    shouldLockBody={false}
  >
    {/* Added this button just for trapping the focus inside the modal so the user cannot tab behind the modal,
		as there is no other tabbable element present */}
    <button className="absolute cursor-default select-none text-transparent outline-none">
      .
    </button>
    <LoadingSpinner />
  </Modal>
);

export default LoadingOverlay;
